<template>
    <div>连接跳转中...</div>
</template>

<script>
import routeHelper from "@util/routeHelper";
import appHelper from "@util/appHelper";
import consoleApi from "@comp/platformApi/consoleApi";

export default {
    name: "share",
    mounted() {
        let paramsStr = routeHelper.getParam(this, 'params');
        let params = {};
        try {
            params = JSON.parse(decodeURIComponent(paramsStr));
        }
        catch(e)
        {
            consoleApi.error(e);
            return;
        }

        consoleApi.log(params);

        let urlParams = params.urlParams || {};

        let options = {};
        if (typeof(urlParams.promotionCode) !== 'undefined')
        {
            options.promotionCode = urlParams.promotionCode;
            consoleApi.log('[sharePage] promotionCode: ' + urlParams.promotionCode);
        }


        // submit promotionCode, then redirect to the path
        appHelper.checkLogin(() => {
            window.app.$router.push(params.routePath, params.routeParams);
        }, options);
    }
}
</script>

<style scoped>

</style>